// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cs-history-tabs {\n  width: clamp(400pt, 30%, 500pt);\n}", ""]);
// Exports
module.exports = exports;
